import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6e08759a from 'nuxt_plugin_plugin_6e08759a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_0c164bdb from 'nuxt_plugin_plugin_0c164bdb' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_8fce3290 from 'nuxt_plugin_recaptcha_8fce3290' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_vuescrollto_2938dd20 from 'nuxt_plugin_vuescrollto_2938dd20' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_dayjsplugin_d55aa018 from 'nuxt_plugin_dayjsplugin_d55aa018' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_09dc3d7c from 'nuxt_plugin_vuesocialsharingplugin_09dc3d7c' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d5425b1e from 'nuxt_plugin_cookieuniversalnuxt_d5425b1e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_webfontloader_002651c9 from 'nuxt_plugin_webfontloader_002651c9' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_axios_8964366e from 'nuxt_plugin_axios_8964366e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_e106b958 from 'nuxt_plugin_deviceplugin_e106b958' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_formatCount_2f02a0a5 from 'nuxt_plugin_formatCount_2f02a0a5' // Source: ../project/filters/formatCount/formatCount.js (mode: 'all')
import nuxt_plugin_formatDate_ecad7712 from 'nuxt_plugin_formatDate_ecad7712' // Source: ../project/filters/formatDate/formatDate.js (mode: 'all')
import nuxt_plugin_formatDateEnd_1f6fde48 from 'nuxt_plugin_formatDateEnd_1f6fde48' // Source: ../project/filters/formatDate/formatDateEnd.js (mode: 'all')
import nuxt_plugin_formatMoney_6f959f83 from 'nuxt_plugin_formatMoney_6f959f83' // Source: ../project/filters/formatMoney/formatMoney.js (mode: 'all')
import nuxt_plugin_formatNumber_4afad797 from 'nuxt_plugin_formatNumber_4afad797' // Source: ../project/filters/formatNumber/formatNumber.js (mode: 'all')
import nuxt_plugin_formatText_3507d5d7 from 'nuxt_plugin_formatText_3507d5d7' // Source: ../project/filters/formatText/formatText.js (mode: 'all')
import nuxt_plugin_formatPhone_497a4da7 from 'nuxt_plugin_formatPhone_497a4da7' // Source: ../project/filters/formatPhone/formatPhone.js (mode: 'all')
import nuxt_plugin_menu_3b8b6f10 from 'nuxt_plugin_menu_3b8b6f10' // Source: ../project/objects/menu.ts (mode: 'all')
import nuxt_plugin_userMenu_15c7952d from 'nuxt_plugin_userMenu_15c7952d' // Source: ../project/objects/userMenu.ts (mode: 'all')
import nuxt_plugin_header_e474abec from 'nuxt_plugin_header_e474abec' // Source: ../project/objects/header.ts (mode: 'all')
import nuxt_plugin_lodash_9d340350 from 'nuxt_plugin_lodash_9d340350' // Source: ../project/plugins/lodash.js (mode: 'all')
import nuxt_plugin_editor_55917180 from 'nuxt_plugin_editor_55917180' // Source: ../project/plugins/editor.js (mode: 'client')
import nuxt_plugin_scrollBar_45dc8b4a from 'nuxt_plugin_scrollBar_45dc8b4a' // Source: ../project/plugins/scrollBar.js (mode: 'all')
import nuxt_plugin_scroll_946c1e06 from 'nuxt_plugin_scroll_946c1e06' // Source: ../project/directives/scroll (mode: 'client')
import nuxt_plugin_inview_0171fa1d from 'nuxt_plugin_inview_0171fa1d' // Source: ../project/directives/in-view (mode: 'client')
import nuxt_plugin_mousemove_013c25c6 from 'nuxt_plugin_mousemove_013c25c6' // Source: ../project/directives/mousemove (mode: 'client')
import nuxt_plugin_touchEvents_7cad8064 from 'nuxt_plugin_touchEvents_7cad8064' // Source: ../project/plugins/touchEvents (mode: 'client')
import nuxt_plugin_vclickoutside_d5f37642 from 'nuxt_plugin_vclickoutside_d5f37642' // Source: ../project/plugins/v-click-outside (mode: 'client')
import nuxt_plugin_gtag_0645264c from 'nuxt_plugin_gtag_0645264c' // Source: ../project/plugins/gtag.js (mode: 'all')
import nuxt_plugin_notification_4aa21d15 from 'nuxt_plugin_notification_4aa21d15' // Source: ../project/plugins/notification (mode: 'client')
import nuxt_plugin_notificationssr_78ec854c from 'nuxt_plugin_notificationssr_78ec854c' // Source: ../project/plugins/notification-ssr (mode: 'server')
import nuxt_plugin_cropper_26a52623 from 'nuxt_plugin_cropper_26a52623' // Source: ../project/plugins/cropper (mode: 'client')
import nuxt_plugin_tooltip_162b67e0 from 'nuxt_plugin_tooltip_162b67e0' // Source: ../project/plugins/tool-tip (mode: 'client')
import nuxt_plugin_nuxtjsstickysidebarclient_abccebe6 from 'nuxt_plugin_nuxtjsstickysidebarclient_abccebe6' // Source: ../project/plugins/nuxtjs-sticky-sidebar.client.js (mode: 'client')
import nuxt_plugin_nuxtjsstickysidebarserver_0fd2fb95 from 'nuxt_plugin_nuxtjsstickysidebarserver_0fd2fb95' // Source: ../project/plugins/nuxtjs-sticky-sidebar.server.js (mode: 'server')
import nuxt_plugin_vueshortkey_1d18eefa from 'nuxt_plugin_vueshortkey_1d18eefa' // Source: ../project/plugins/vue-shortkey.js (mode: 'client')
import nuxt_plugin_vcalendar_20821038 from 'nuxt_plugin_vcalendar_20821038' // Source: ../project/plugins/v-calendar.js (mode: 'client')
import nuxt_plugin_html2pdf_9e0e21fc from 'nuxt_plugin_html2pdf_9e0e21fc' // Source: ../project/plugins/html2pdf.js (mode: 'client')
import nuxt_plugin_equalHeight_74f40846 from 'nuxt_plugin_equalHeight_74f40846' // Source: ../project/plugins/equalHeight.js (mode: 'client')
import nuxt_plugin_draggable_31f14974 from 'nuxt_plugin_draggable_31f14974' // Source: ../project/plugins/draggable.js (mode: 'client')
import nuxt_plugin_eventBus_5e4e6d47 from 'nuxt_plugin_eventBus_5e4e6d47' // Source: ../project/plugins/eventBus.js (mode: 'all')
import nuxt_plugin_jsonld_f7de2ca6 from 'nuxt_plugin_jsonld_f7de2ca6' // Source: ../project/plugins/jsonld.js (mode: 'all')
import nuxt_plugin_author_1bde14a2 from 'nuxt_plugin_author_1bde14a2' // Source: ../project/plugins/author.js (mode: 'all')
import nuxt_plugin_vuegoodtable_2bc359e2 from 'nuxt_plugin_vuegoodtable_2bc359e2' // Source: ../project/plugins/vue-good-table (mode: 'client')
import nuxt_plugin_vueawesomeswiper_78f740f3 from 'nuxt_plugin_vueawesomeswiper_78f740f3' // Source: ../project/plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_auth_3b518747 from 'nuxt_plugin_auth_3b518747' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_axios_11580aeb from 'nuxt_plugin_axios_11580aeb' // Source: ../project/plugins/axios.js (mode: 'all')
import nuxt_plugin_user_4005a03c from 'nuxt_plugin_user_4005a03c' // Source: ../project/plugins/user.js (mode: 'all')
import nuxt_plugin_userInit_51fac99c from 'nuxt_plugin_userInit_51fac99c' // Source: ../project/plugins/userInit.js (mode: 'all')
import nuxt_plugin_meta_59753ca6 from 'nuxt_plugin_meta_59753ca6' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$megasreda', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$megasreda : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$megasreda
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru","prefix":"og: https:\u002F\u002Fogp.me\u002Fns#"},"noscript":[{"innerHTML":"Сайт не работает без javascript. Включите поддержку javascript в настройках браузера!","body":true}],"title":"Мегасреда - профессиональная платформа для людей в деле","titleTemplate":"%s","meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"mailru-verification","content":"4eb87cf9695b30c8"},{"hid":"description","name":"description","content":"Мегасреда - бесплатная медиаплатформа для бухгалтеров, юристов, кадровиков и предпринимателей. Здесь можно найти и изучить тысячи материалов на тему законодательства. В сервисе удобно следить за понравившимися авторами и компаниями, а также находить актуальные материалы, используя журналы."},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:description","property":"og:description","content":"Мегасреда - бесплатная медиаплатформа для бухгалтеров, юристов, кадровиков и предпринимателей. Здесь можно найти и изучить тысячи материалов на тему законодательства. В сервисе удобно следить за понравившимися авторами и компаниями, а также находить актуальные материалы, используя журналы."},{"hid":"og:title","property":"og:title","content":"Мегасреда - профессиональная платформа для людей в деле"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fmegasreda.ru\u002Fimg\u002Fmegasreda_cover.jpg"},{"hid":"og:image:type","property":"og:image:type","content":"image\u002Fjpeg"},{"hid":"og:image:alt","property":"og:image:alt","content":"Мегасреда - бесплатная медиаплатформа для бухгалтеров, юристов, кадровиков и предпринимателей. Здесь можно найти и изучить тысячи материалов на тему законодательства. В сервисе удобно следить за понравившимися авторами и компаниями, а также находить актуальные материалы, используя журналы."},{"hid":"og:image:width","property":"og:image:width","content":1200},{"hid":"og:image:height","property":"og:image:height","content":630},{"hid":"vk:image","property":"vk:image","content":"https:\u002F\u002Fmegasreda.ru\u002Fimg\u002Fmegasreda_cover.jpg"},{"hid":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fmegasreda.ru\u002Fimg\u002Fmegasreda_cover.jpg"}],"link":[{"rel":"icon","href":"\u002Ffavicon.svg"}],"script":[{"src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","defer":true},{"src":"https:\u002F\u002Fyastatic.net\u002Fs3\u002Fpassport-sdk\u002Fautofill\u002Fv1\u002Fsdk-suggest-latest.js","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__megasreda_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__MEGASREDA__ && window.__MEGASREDA__.state) {
      store.replaceState(window.__MEGASREDA__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6e08759a === 'function') {
    await nuxt_plugin_plugin_6e08759a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0c164bdb === 'function') {
    await nuxt_plugin_plugin_0c164bdb(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_8fce3290 === 'function') {
    await nuxt_plugin_recaptcha_8fce3290(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_2938dd20 === 'function') {
    await nuxt_plugin_vuescrollto_2938dd20(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_d55aa018 === 'function') {
    await nuxt_plugin_dayjsplugin_d55aa018(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_09dc3d7c === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_09dc3d7c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d5425b1e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d5425b1e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_002651c9 === 'function') {
    await nuxt_plugin_webfontloader_002651c9(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_8964366e === 'function') {
    await nuxt_plugin_axios_8964366e(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_e106b958 === 'function') {
    await nuxt_plugin_deviceplugin_e106b958(app.context, inject)
  }

  if (typeof nuxt_plugin_formatCount_2f02a0a5 === 'function') {
    await nuxt_plugin_formatCount_2f02a0a5(app.context, inject)
  }

  if (typeof nuxt_plugin_formatDate_ecad7712 === 'function') {
    await nuxt_plugin_formatDate_ecad7712(app.context, inject)
  }

  if (typeof nuxt_plugin_formatDateEnd_1f6fde48 === 'function') {
    await nuxt_plugin_formatDateEnd_1f6fde48(app.context, inject)
  }

  if (typeof nuxt_plugin_formatMoney_6f959f83 === 'function') {
    await nuxt_plugin_formatMoney_6f959f83(app.context, inject)
  }

  if (typeof nuxt_plugin_formatNumber_4afad797 === 'function') {
    await nuxt_plugin_formatNumber_4afad797(app.context, inject)
  }

  if (typeof nuxt_plugin_formatText_3507d5d7 === 'function') {
    await nuxt_plugin_formatText_3507d5d7(app.context, inject)
  }

  if (typeof nuxt_plugin_formatPhone_497a4da7 === 'function') {
    await nuxt_plugin_formatPhone_497a4da7(app.context, inject)
  }

  if (typeof nuxt_plugin_menu_3b8b6f10 === 'function') {
    await nuxt_plugin_menu_3b8b6f10(app.context, inject)
  }

  if (typeof nuxt_plugin_userMenu_15c7952d === 'function') {
    await nuxt_plugin_userMenu_15c7952d(app.context, inject)
  }

  if (typeof nuxt_plugin_header_e474abec === 'function') {
    await nuxt_plugin_header_e474abec(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_9d340350 === 'function') {
    await nuxt_plugin_lodash_9d340350(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_editor_55917180 === 'function') {
    await nuxt_plugin_editor_55917180(app.context, inject)
  }

  if (typeof nuxt_plugin_scrollBar_45dc8b4a === 'function') {
    await nuxt_plugin_scrollBar_45dc8b4a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scroll_946c1e06 === 'function') {
    await nuxt_plugin_scroll_946c1e06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_inview_0171fa1d === 'function') {
    await nuxt_plugin_inview_0171fa1d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mousemove_013c25c6 === 'function') {
    await nuxt_plugin_mousemove_013c25c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_touchEvents_7cad8064 === 'function') {
    await nuxt_plugin_touchEvents_7cad8064(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vclickoutside_d5f37642 === 'function') {
    await nuxt_plugin_vclickoutside_d5f37642(app.context, inject)
  }

  if (typeof nuxt_plugin_gtag_0645264c === 'function') {
    await nuxt_plugin_gtag_0645264c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notification_4aa21d15 === 'function') {
    await nuxt_plugin_notification_4aa21d15(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_notificationssr_78ec854c === 'function') {
    await nuxt_plugin_notificationssr_78ec854c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cropper_26a52623 === 'function') {
    await nuxt_plugin_cropper_26a52623(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tooltip_162b67e0 === 'function') {
    await nuxt_plugin_tooltip_162b67e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtjsstickysidebarclient_abccebe6 === 'function') {
    await nuxt_plugin_nuxtjsstickysidebarclient_abccebe6(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtjsstickysidebarserver_0fd2fb95 === 'function') {
    await nuxt_plugin_nuxtjsstickysidebarserver_0fd2fb95(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueshortkey_1d18eefa === 'function') {
    await nuxt_plugin_vueshortkey_1d18eefa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_20821038 === 'function') {
    await nuxt_plugin_vcalendar_20821038(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_html2pdf_9e0e21fc === 'function') {
    await nuxt_plugin_html2pdf_9e0e21fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_equalHeight_74f40846 === 'function') {
    await nuxt_plugin_equalHeight_74f40846(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_draggable_31f14974 === 'function') {
    await nuxt_plugin_draggable_31f14974(app.context, inject)
  }

  if (typeof nuxt_plugin_eventBus_5e4e6d47 === 'function') {
    await nuxt_plugin_eventBus_5e4e6d47(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_f7de2ca6 === 'function') {
    await nuxt_plugin_jsonld_f7de2ca6(app.context, inject)
  }

  if (typeof nuxt_plugin_author_1bde14a2 === 'function') {
    await nuxt_plugin_author_1bde14a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegoodtable_2bc359e2 === 'function') {
    await nuxt_plugin_vuegoodtable_2bc359e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_78f740f3 === 'function') {
    await nuxt_plugin_vueawesomeswiper_78f740f3(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_3b518747 === 'function') {
    await nuxt_plugin_auth_3b518747(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_11580aeb === 'function') {
    await nuxt_plugin_axios_11580aeb(app.context, inject)
  }

  if (typeof nuxt_plugin_user_4005a03c === 'function') {
    await nuxt_plugin_user_4005a03c(app.context, inject)
  }

  if (typeof nuxt_plugin_userInit_51fac99c === 'function') {
    await nuxt_plugin_userInit_51fac99c(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_59753ca6 === 'function') {
    await nuxt_plugin_meta_59753ca6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
